<template>
  <div class="flex gap-4 flex-row items-start justify-between w-full">
    <div>
      <div class="flex -mx-2">
        <ui-button-new class="m-2" icon="fas fa-file" @click="$emit('newFile')">New File</ui-button-new>
        <ui-button-new class="m-2" icon="fas fa-folder" @click="$modals.open('mobile-filesystem-new-folder-modal', { filesystemId, refresh, close:()=>{} })">New Folder</ui-button-new>
      </div>
    </div>
    <aside class="flex flex-col">
      <mobile-filesystem-search @searchCleared="handleSearchCleared" @searching="handleSearch" />
    </aside>
  </div>
</template>

<script>
export default {
  props: {
    refresh: Function,
    filesystemId: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
    handleSearch(searchTerm){
      this.$emit('searching', searchTerm);
    },
    handleSearchCleared(searchTerm){
      this.$emit('searchCleared');
    }
  },
  mounted() {

  }
}
</script>
